// @flow

import React, { Component } from 'react';

import { Questions } from '../../assets/model';

import type answer from './_QuestionHandler';

type Props = {
  question: number,
  onClick?: (number: number, answer: answer) => void,
  onNext?: () => void
};

type State = {
  value: string
};

class TextInput extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      value: ''
    };
  }

  _handleChange = (event, answer) => {
    this.setState(
      {
        value: event.target.value
      },
      () => {
        answer.value = this.state.value;
        this.props.onClick(this.props.question, answer);
      }
    );
  };

  render() {
    const { question } = this.props;
    const { text } = Questions[question].answers[0];
    const answer = Questions[question].answers[0];
    return (
      <React.Fragment>
        <div className="inputContainer">
          <div className="inputLeft">
            <p className="inputDescription">PLZ Ihrer Immobilie</p>
            <div className="inputFieldContainer">
              <input
                onChange={e => {
                  this._handleChange(e, answer);
                }}
                value={this.state.value}
                type="text"
                className="slider-input effect-2"
              />
              <span className="focus-border" />
            </div>
            <p className="inputDescription">
              Die Lage Ihrer Immobilie bildet die Grundlage für eine genaue
              Wertermittlung.
            </p>
          </div>
          <div className="inputRight" />
        </div>
        <div className="bottomBar bottomBar--buttonRight">
          <div
            onClick={
              // this.props.onNext(Questions[question].answers[0].nextQuestion);
              this.props.onNext
            }
            className="button"
          >
            Weiter
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default TextInput;



// WEBPACK FOOTER //
// ./src/components/questions/TextInput.js